export function formatLocalPhoneNumberToE164 (phoneString: string): string {
    let match = phoneString.match(/^\((\d{3})\) (\d{3})-(\d{4})$/);
    if (match) {
        return "+1" + match[1] + match[2] + match[3];
    }
    return phoneString;
};